export default {
  // 面包屑
  mapManagement: 'Map Management',
  mapDetail: 'Map Details',
  backToList: 'Back to List',
  back: 'Back',

  // 视图切换
  view2D: '2D View',
  view3D: '3D View',

  // 空状态
  mapNotFound: 'Map does not exist or has been deleted',
  missingMapId: 'Missing map ID',
  missingMapData: 'Missing map data. Please access details from map management list',

  // 提示信息
  map3DLoadSuccess: '3D point cloud loaded successfully ({count} points)',
  map3DLoadFailed: '3D point cloud load failed: {error}',
  pointsLoadSuccess: 'Point list loaded successfully',
  pointsLoadFailed: 'Failed to load point list',
  pointAddSuccess: 'Point "{name}" added successfully',
  pointDeleteSuccess: 'Point "{name}" deleted successfully',
  pointUpdateSuccess: 'Point "{name}" position updated successfully',
  newPoint: 'New Point',
  pointNumber: 'Point {n}',
  pointSaveFailed: 'Failed to save points',
  pointSaveInProgress: 'Points are being saved, please try again later',

  // 禁行区相关
  forbiddenZoneAddSuccess: 'Forbidden zone "{name}" saved',
  forbiddenZoneUpdateSuccess: 'Forbidden zone "{name}" updated',
  forbiddenZoneDeleteSuccess: 'Forbidden zone "{name}" deleted',
  forbiddenZoneSaveFailed: 'Failed to save forbidden zones',
  forbiddenZoneSaveInProgress: 'Forbidden zones are being saved, please try again later',
  forbiddenZoneCannotCoverPoints: 'Forbidden zone cannot cover existing points. Please move or delete "{name}" first',
  missingMapIdForForbiddenZone: 'Missing map ID, cannot save forbidden zones',
  forbiddenZoneLoadFailed: 'Failed to load forbidden zone list',

  // 地图上传
  mapUploadSuccess: 'Map uploaded successfully',
  mapUploadFailed: 'Map upload failed',
  mapUploadInProgress: 'Map is being uploaded, please try again later',
  missingMapIdForUpload: 'Missing map ID, cannot upload map',
  missingMapFile: 'Missing map file',

  // Map3D 组件相关
  loadingPointCloud: 'Loading point cloud...',
  resetCamera: 'Reset Camera View',
  checkPointCloudUrl: 'Please check the point cloud file URL or network connection and try again',
  missingPointCloudUrl: 'Point cloud file URL not configured (yun_map_minio_path)',

  // Map2D 组件相关
  checkMapUrl: 'Please check the map resource URL or cross-origin configuration and try again',
  loadingMap: 'Loading map...',
  resetView: 'Reset View',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',
  uploadMap: 'Upload Map Update',
  downloadMap: 'Download Map',
  editPoints: 'Edit Points',
  exitEdit: 'Exit Edit',
  addPointMode: 'Add Point Mode',
  exitAddPointMode: 'Exit Add Mode',
  deleteSelectedPoint: 'Delete Selected Point',
  editAfterSave: 'Edit Details After Save',
  saveDirectly: 'Save Directly',
  cancelTempPoint: 'Cancel Temp Point',
  forbiddenZoneMode: 'Forbidden Zone (Polygon)',
  exitForbiddenZone: 'Exit Forbidden Zone',
  undoLastVertex: 'Undo Last Vertex',
  closePolygon: 'Close Polygon and Add',
  deleteSelectedZone: 'Delete Selected Zone',

  // 编辑模式提示
  editModeTitle: 'Edit Mode',
  addModeTitle: 'Add Mode',
  zoneModeTitle: 'Forbidden Zone',
  zoneModeTip: 'Left-click to add vertices; need at least 3 points to close; Alt+drag to pan canvas; Esc to clear current polyline; drag vertices to fine-tune saved zones',
  addModeTip: 'Click map to place temporary point (not in forbidden zones); drag point and arrow to adjust position/yaw; checkmark to save directly, form button to edit details then save, X to cancel',
  selectedPointTip: 'Point selected: drag position or arrow to adjust yaw, confirm update after release (press Esc during drag to cancel); double-click/right-click for full edit, red button on right to delete',
  normalModeTip: 'Click point to select; after selection drag position/yaw and confirm update, or double-click/right-click for full edit; to delete, select first then click red button on right',

  // 鼠标位置显示
  mousePosition: 'Position',

  // 模态框
  confirmDeletePoint: 'Confirm Delete Point',
  confirmDelete: 'Confirm Delete',
  confirmAddPoint: 'Confirm Add Point',
  add: 'Add',
  editPoint: 'Edit Point',
  save: 'Save',
  cancel: 'Cancel',

  // 表单标签
  pointName: 'Point Name',
  xCoordinate: 'X Coordinate',
  yCoordinate: 'Y Coordinate',
  yawAngle: 'Yaw Angle',
  enterPointName: 'Please enter point name',
  enterXCoordinate: 'Please enter X coordinate',
  enterYCoordinate: 'Please enter Y coordinate',
  enterYawAngle: 'Please enter yaw angle, 0-6.28',

  // 提示和警告
  deletePointConfirm: 'Confirm delete point "{name}"?',
  deletePointWarning: 'This operation cannot be undone. Please proceed with caution.',
  pointPositionTip: 'Click position on map to quickly fill coordinates, yaw range: 0-6.28 radians',
  editPointTip: 'Modify point name, coordinates and yaw angle, takes effect after saving',
  cannotMoveOutsideMap: 'Cannot move point outside map boundaries',
  cannotMoveToForbiddenZone: 'Cannot move point into forbidden zone',
  cannotAddOutsideMap: 'Cannot add point outside map boundaries',
  cannotAddInForbiddenZone: 'Cannot add point in forbidden zone',
  cannotSaveOutsideMap: 'Cannot save point outside map boundaries',
  cannotSaveInForbiddenZone: 'Cannot save point in forbidden zone',
  needAtLeast3Vertices: 'Need at least 3 vertices to close',
  forbiddenZoneCannotCoverPointsShort: 'Forbidden zone cannot cover existing points, please move or delete "{name}" first',

  // 地图相关
  missingMapUrl: 'Map URL not configured (map_minio_path)',
  mapNameMustBe: 'Upload file name must be map.pgm',
  noMapUrlCannotDownload: 'Map URL not configured, cannot download',
  downloadStarted: 'Download started',

  // Voice navigation
  voiceNoTranscript: 'No speech detected. Please try voice input again',
  voiceTranscribeFailed: 'Voice recognition failed. Please try again',
  voiceNoPointsMatched: 'No map points recognized. Please try voice input again',
  voiceNoNavigationTargets: 'No navigation points recognized. Please use voice input first',
  voiceTaskCreateSuccess: 'Task created successfully',
  voiceTaskCreateFailed: 'Failed to create task',

  // 通用错误
  missingMapIdForPoint: 'Missing map ID, cannot save points',
  operationFailed: 'Operation failed',

  // 按钮文本
  confirm: 'Confirm',
  undo: 'Undo',

  // 提示信息
  tip: 'Tip',
  yawRangeTip: 'Click position on map to quickly fill coordinates, yaw range: 0-6.28 radians',
  editTip: 'Modify point name, coordinates and yaw angle, takes effect after saving',

  // 错误和警告信息
  mapLoadError: 'Map URL not configured (map_minio_path)',
  loadFailedHttp: 'Load failed HTTP {status}',
  parsePgmFailed: 'Failed to parse PGM format, please confirm the file format is correct',
  mapLoadFailed: 'Map load failed',
  forbiddenZoneNumber: 'Forbidden Zone {n}',
  confirmDeletePointMessage: 'Confirm delete point "{name}"?',
  adjustingForbiddenZoneCannotCoverPoints: 'Adjusted forbidden zone cannot cover existing points, please move or delete "{name}" first',
  uploadFileNameWarning: 'Upload file name must be map.pgm',
  noMapUrlDownloadWarning: 'Map URL not configured, cannot download',
  downloadFailedHttp: 'Download failed HTTP {status}',
  downloadMapFailed: 'Map download failed',
  downloadMapSuccess: 'Download started',
  receivedPointsData: 'Map2D received points data:',
}